module.exports = __webpack_public_path__ + "img/alerts-5.6733c365.gif";